import React, {useContext, useState} from 'react';
import styles from "./generate-sales-report.module.scss";
import logo from "../../../../../assets/security-details-generate-sales-report.svg";
import SecurityService from "../../../../../services/security-service";
import { SecurityContext } from "../../../../../context/security-context";
import ModalCustom from "../../../../../components/modal/modal";
import ErrorModalContent from "../modal-content-error/modal-content-error";
import {ORDERS_SUBMIT_ERROR} from "../../../../../helpr/constants";

const GenerateSalesReport = () => {
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const action = 'Generate Sales Report';
  const { securityState } = useContext(SecurityContext);
  const securityService = new SecurityService();
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    title: '',
    value: ''
  });
  const exportSalesReport = async () => {
    try {
      const resp = await securityService.generateSalesReport(securityState.securityId);
      window.open(resp['s3FileUrl']);
    } catch(error){
      console.log(error);
      if(error.message === 'Request failed with status code 405') {
        setErrorMsg({
          ...errorMsg,
          title: 'SALES REPORT GENERATION FAILED',
          value: 'You may have insufficient applications or exceeded your allocation.'
        });
      } else {
        setErrorMsg({
          ...errorMsg,
          title: ERROR_TITLE,
          value: ORDERS_SUBMIT_ERROR
        })
      }
      setShow(true)
    }
  }

  //Get context data
  return (
    <>
      <div onClick={() => exportSalesReport()} className={styles['logo']}>
        <img alt={action} src={logo} />
        <label>{action}</label>
      </div>
      <ModalCustom
        show={show}
        title={action}
        onClose={() => setShow(false)}
        component={<ErrorModalContent title={errorMsg.title} message={errorMsg.value} onClose={() => setShow(false)}/>}
        style={styles['generate-sales-report-modal']} />
    </>
  );
}

export default GenerateSalesReport;
